"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import CommonImage from "@/components/common/image/CommonImage";
import { FaChevronLeft, FaChevronRight, FaPlay } from "react-icons/fa6";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import HomePageService from "@/services/api/HomeService";
import PlayYoutubeModal from "@/components/common/Modal/PlayYoutubeModal";
import { usePublicFetch } from "@/hook/usePublicFetch";
import ReviewModal from "@/components/common/Modal/ReviewModal";

export default function SuccessStoriesSection({ successStories }) {
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);

  const openModal = (video) => {
    setSelectedStory(video);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedStory(null);
  };

  return (
    <section className="success_stories-section section_padding">
      <div className="container">
        <div className="success-stories-wrap grid grid-cols-12 gap-6">
          <div className="lg:col-span-4 col-span-12">
            <div className="section_title">
              <h2 className="title">
                <span className="w-8 h-8">
                  <CommonImage
                    src="/images/admission-icon/success-icon.png"
                    className="img-icon"
                    alt="Book Icon"
                  />
                </span>
                সাফল্যের শীর্ষে যারা
              </h2>
              <p className="short-des">
                ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
                গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
                মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
              </p>
            </div>

            <Link href="/success-stories" className="secondary-btn mt-6">
              আরো দেখুন
              <Image
                src={"/images/admission-icon/arrow-left.png"}
                alt="Arrow Right"
                className="arrow-icon"
                width={16}
                height={16}
              />
            </Link>
          </div>

          <div className="lg:col-span-8 col-span-12">
            <div className="stories-content-card min-h-[216px]">
              {loading ? (
                <div className="grid grid-cols-2 gap-6">
                  {[1, 2].map((item) => (
                    <div
                      key={item}
                      className="success-stories-card border p-4 rounded-xl animate-pulse"
                    >
                      <div className="w-full h-40 bg-gray-300 rounded mb-4"></div>

                      <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
                      <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
                      <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
                      <div className="h-4 bg-gray-300 rounded w-2/3"></div>
                    </div>
                  ))}
                </div>
              ) : (
                <Swiper
                  slidesPerView={2}
                  spaceBetween={24}
                  speed={1000}
                  loop={true}
                  autoplay={true}
                  navigation={{
                    nextEl: ".success-stories-prev",
                    prevEl: ".success-stories-next",
                  }}
                  modules={[Navigation, Autoplay]}
                  responsive={{
                    0: { spaceBetween: 10 },
                    576: { spaceBetween: 15 },
                    992: { spaceBetween: 24 },
                  }}
                  className="stories-slider"
                >
                  {successStories?.map((story, index) => (
                    <SwiperSlide key={index}>
                      <div className="success-stories-card">
                        <div className="student-image-wrap">
                          <div className="success-student-image">
                            <Image
                             src={
                                story.profile_pic ??
                                "/images/home/success-student.png"
                              }
                              className="h-full w-full"
                              alt={story.name}
                              width={120}
                              height={120}
                            />
                          </div>
                          <button
                            className="video-play-btn"
                            onClick={() => openModal(story)}
                          >
                            <span>
                              <FaPlay className="icon" />
                            </span>
                            {story?.type == "Video"
                              ? " ভিডিও  দেখুন"
                              : " রিভিউ দেখুন"}
                          </button>
                        </div>
                        <div className="success-student-information">
                          <h2 className="name">{story.name}</h2>
                          <p className="text unit">ইউনিটঃ {story.unit}</p>
                          {story?.subject && (
                            <p className="text">বিষয়ঃ {story.subject}</p>
                          )}
                          <p className="text">
                            <span>সেশনঃ {story.session}</span>
                            <span>মেধা অবস্থানঃ {story.position}</span>
                          </p>
                          <p className="text">{story.university}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
              {/* Slider Arrow */}
              <div className="success-stories-arrow">
                <div className="success-stories-next">
                  <button className="arrow-icon">
                    <FaChevronLeft />
                  </button>
                </div>
                <div className="success-stories-prev">
                  <button className="arrow-icon">
                    <FaChevronRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedStory?.type == "Video" && (
        <PlayYoutubeModal
          modalOpen={modalOpen}
          closeModal={closeModal}
          link={selectedStory?.video_link}
        />
      )}
      {(!selectedStory?.type ||
        selectedStory?.type === "Text" ||
        selectedStory?.type === "Image") && (
        <ReviewModal
          modalOpen={modalOpen}
          closeModal={closeModal}
          selectedStory={selectedStory}
        />
      )}
    </section>
  );
}
